import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { ToggleExecuteFlow } from '../../tickets/actions/edit-ticket.actions';
import {
  AssignClubCodeChanged,
  AssignClubEndDateChanged,
  AssignClubStartDateChanged,
  CampaignsItemsPerPageChanged,
  CampaignsOrderingChanged,
  CampaignsPagingChanged,
  CampaignsPanelLoading,
  CampaignsSortingChanged,
  CardsPanelLoading,
  CheckbookDetailsModal,
  CheckbooksDisplayedColumnsInit,
  CheckbooksItemsPerPageChanged,
  CheckbooksOrderingChanged,
  CheckbooksPagingChanged,
  CheckbooksPanelLoading,
  CheckbooksSortingChanged,
  ClosePanel,
  ClubsDisplayedColumnsInit,
  ClubsItemsPerPageChanged,
  ClubsOrderingChanged,
  ClubsPagingChanged,
  ClubsPanelLoading,
  ClubsSortingChanged,
  CouponsFilterChanged,
  CouponsItemsPerPageChanged,
  CouponsOrderingChanged,
  CouponsPagingChanged,
  CouponsPanelLoading,
  CouponsSortingChanged,
  CustomerTagsItemsPerPageChanged,
  CustomerTagsOrderingChanged,
  CustomerTagsPagingChanged,
  CustomerTagsPanelLoading,
  CustomerTagsSortingChanged,
  CustomerTagsStatusChanged,
  GetActiveClubsSuccess,
  GetAssignmentsSuccess,
  GetCampaignsCountTableSuccess,
  GetCampaignsTableFailed,
  GetCampaignsTableSuccess,
  GetCheckbooksCountTableSuccess,
  GetCheckbooksTableFailed,
  GetCheckbooksTableSuccess,
  GetClubsCountTableSuccess,
  GetClubsTableFailed,
  GetClubsTableSuccess,
  GetCountriesSuccess,
  GetCouponsCountSuccess,
  GetCouponsTableFailed,
  GetCouponsTableSuccess,
  GetCustomerTagsCountSuccess,
  GetCustomerTagsTableFailed,
  GetCustomerTagsTableSuccess,
  GetDetailedRFMAnalysisSuccess,
  GetLoyaltyCardsTableFailed,
  GetLoyaltyCardsTableSuccess,
  GetMemberTagsCountSuccess,
  GetMemberTagsTableFailed,
  GetMemberTagsTableSuccess,
  GetPointLogCountTableSuccess,
  GetPointLogTableFailed,
  GetPointLogTableSuccess,
  GetSeveritiesSuccess,
  GetTicketCategoriesSuccess,
  GetTicketsCountTableSuccess,
  GetTicketsTableFailed,
  GetTicketsTableSuccess,
  GetTicketStatusesSuccess,
  GetTransactionsCountTableSuccess,
  GetTransactionsTableFailed,
  GetTransactionsTableSuccess,
  ItemsPerPageChanged,
  MemberCloseEditTicketModal,
  MemberCreateTicketModal,
  MemberEditTicketModal,
  MemberTagsItemsPerPageChanged,
  MemberTagsOrderingChanged,
  MemberTagsPagingChanged,
  MemberTagsPanelLoading,
  MemberTagsSortingChanged,
  MemberTagsStatusChanged,
  MemberTicketMatchMemberSuccess,
  MemberTicketRemoveMember,
  MemberTicketSearchFieldChanged,
  OpenCampaignsPanel,
  OpenCardsPanel,
  OpenCheckbooksPanel,
  OpenClubsPanel,
  OpenCouponsPanel,
  OpenPointLogPanel,
  OpenTicketsPanel,
  OpenTransactionsPanel,
  OrderingChanged,
  OrderingInit,
  PagingChanged,
  PointLogDisplayedColumnsInit,
  PointLogItemsPerPageChanged,
  PointLogOrderingChanged,
  PointLogPagingChanged,
  PointLogPanelLoading,
  PointLogSortingChanged,
  SetSelectedCheckbook,
  SortingChanged,
  SortingInit,
  TicketAssigneeChanged,
  TicketBodyChanged,
  TicketCategoryChanged,
  TicketCountryChanged,
  TicketSeverityChanged,
  TicketsItemsPerPageChanged,
  TicketsOrderingChanged,
  TicketsPagingChanged,
  TicketsPanelLoading,
  TicketsSortingChanged,
  TicketStatusChanged,
  TicketSubjectChanged,
  TransactionsDisplayedColumnsInit,
  TransactionsItemsPerPageChanged,
  TransactionsOrderingChanged,
  TransactionsPagingChanged,
  TransactionsPanelLoading,
  TransactionsSortingChanged,
  ViewMember,
  ViewMemberSearchPage,
} from '../actions/lmembers-summary.actions';
import { LoyaltyMemberSummaryPanel, MembersSummaryState } from '../models/member-summary.models';

const noPanelsLoading: Record<LoyaltyMemberSummaryPanel, boolean> = {
  cards: false,
  campaigns: false,
  checkbooks: false,
  pointLog: false,
  transactions: false,
  tickets: false,
  clubs: false,
  coupons: false,
  memberTags: false,
  customerTags: false,
};

const setPanelLoading = (
  state: MembersSummaryState,
  panel: LoyaltyMemberSummaryPanel,
  loading: boolean,
): MembersSummaryState => ({
  ...state,
  panelLoading: { ...state.panelLoading, [panel]: loading },
});

const initialState: MembersSummaryState = {
  member: '',
  itemsPerPage: [5, 10, 20, 50],
  itemsNumber: 10,
  selectedSortField: '',
  selectedOrder: '',
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  totalPages: 0,
  sortFieldOptions: [],
  orderFieldOptions: [],
  cards: [],
  displayedColumns: {},
  cardNumber: '',
  paCardBatch: '',
  campaigns: [],
  checkbooks: [],
  checkbooksDisplayedColumns: {},
  checkbooksTable: [],
  selectedCheckbookId: null,
  pointLog: [],
  pointLogDisplayedColumns: {},
  clubs: [],
  clubsDisplayedColumns: {},
  activeClubs: [],
  assignClubForm: {
    clubCode: '',
    startDate: null,
    endDate: null,
  },
  transactions: [],
  transactionsDisplayedColumns: {},
  tickets: [],
  editTicketState: {
    isCreateNewTicket: true,
    ticket: [],
    ticketCategoryValues: [],
    ticketCategory: 0,
    ticketStatusValues: [],
    ticketStatus: 0,
    ticketAssigneeValues: [],
    ticketAssignee: 0,
    ticketSeverityValues: [],
    ticketSeverity: 0,
    subject: '',
    countryValues: [],
    country: 0,
    body: '',
    searchField: '',
    customerAdded: false,
    memberColumns: [],
    member: [],
    submit: false,
  },
  coupons: [],
  couponsDisplayedColumns: {},
  couponsTotalPages: 0,
  couponsFilter: {
    used: null,
    given: null,
    couponSetId: null,
  },
  memberTags: [],
  memberTagsTotalPages: 0,
  memberTagsActive: true,
  customerTags: [],
  customerTagsTotalPages: 0,
  customerTagsActive: true,
  detailedRFM: [],
  panelLoading: { ...noPanelsLoading },
};

export const MemberSummaryReducer = createReducer(
  initialState,
  on(ViewMember, (state, { member }) => ({
    ...state,
    member,
  })),
  // === Panel loading flags: set on start, cleared on the panel's Success/Failed ===
  on(CardsPanelLoading, (state) => setPanelLoading(state, 'cards', true)),
  on(CampaignsPanelLoading, (state) => setPanelLoading(state, 'campaigns', true)),
  on(CheckbooksPanelLoading, (state) => setPanelLoading(state, 'checkbooks', true)),
  on(PointLogPanelLoading, (state) => setPanelLoading(state, 'pointLog', true)),
  on(TransactionsPanelLoading, (state) => setPanelLoading(state, 'transactions', true)),
  on(TicketsPanelLoading, (state) => setPanelLoading(state, 'tickets', true)),
  on(ClubsPanelLoading, (state) => setPanelLoading(state, 'clubs', true)),
  on(CouponsPanelLoading, (state) => setPanelLoading(state, 'coupons', true)),
  on(MemberTagsPanelLoading, (state) => setPanelLoading(state, 'memberTags', true)),
  on(CustomerTagsPanelLoading, (state) => setPanelLoading(state, 'customerTags', true)),
  on(GetLoyaltyCardsTableFailed, (state) => setPanelLoading(state, 'cards', false)),
  on(GetCampaignsTableFailed, (state) => setPanelLoading(state, 'campaigns', false)),
  on(GetCheckbooksTableFailed, (state) => setPanelLoading(state, 'checkbooks', false)),
  on(GetPointLogTableFailed, (state) => setPanelLoading(state, 'pointLog', false)),
  on(GetTransactionsTableFailed, (state) => setPanelLoading(state, 'transactions', false)),
  on(GetTicketsTableFailed, (state) => setPanelLoading(state, 'tickets', false)),
  on(GetClubsTableFailed, (state) => setPanelLoading(state, 'clubs', false)),
  on(GetCouponsTableFailed, (state) => setPanelLoading(state, 'coupons', false)),
  on(GetMemberTagsTableFailed, (state) => setPanelLoading(state, 'memberTags', false)),
  on(GetCustomerTagsTableFailed, (state) => setPanelLoading(state, 'customerTags', false)),
  on(GetLoyaltyCardsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'cards', false),
    cards: res,
    totalPages: res.length,
  })),
  on(GetCampaignsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'campaigns', false),
    campaigns: res,
  })),
  on(GetCampaignsCountTableSuccess, GetTicketsCountTableSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(GetCheckbooksTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'checkbooks', false),
    checkbooks: res,
  })),
  on(GetCheckbooksCountTableSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(GetPointLogTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'pointLog', false),
    pointLog: res,
  })),
  on(GetPointLogCountTableSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(GetTransactionsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'transactions', false),
    transactions: res,
  })),
  on(GetTransactionsCountTableSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(GetCouponsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'coupons', false),
    coupons: res,
  })),
  on(GetCouponsCountSuccess, (state, { res }) => ({
    ...state,
    couponsTotalPages: res,
  })),
  on(CouponsFilterChanged, (state, { filter }) => ({
    ...state,
    couponsFilter: filter,
  })),
  on(GetMemberTagsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'memberTags', false),
    memberTags: res,
  })),
  on(GetMemberTagsCountSuccess, (state, { res }) => ({
    ...state,
    memberTagsTotalPages: res,
  })),
  on(MemberTagsStatusChanged, (state, { active }) => ({
    ...state,
    memberTagsActive: active,
  })),
  on(MemberTagsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(MemberTagsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(MemberTagsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(MemberTagsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(GetCustomerTagsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'customerTags', false),
    customerTags: res,
  })),
  on(GetCustomerTagsCountSuccess, (state, { res }) => ({
    ...state,
    customerTagsTotalPages: res,
  })),
  on(CustomerTagsStatusChanged, (state, { active }) => ({
    ...state,
    customerTagsActive: active,
  })),
  on(CustomerTagsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CustomerTagsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CustomerTagsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CustomerTagsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(GetDetailedRFMAnalysisSuccess, (state, { res }) => ({
    ...state,
    detailedRFM: res,
  })),
  on(GetTicketCategoriesSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      ticketCategoryValues: res,
    },
  })),
  on(GetSeveritiesSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      ticketSeverityValues: res,
    },
  })),
  on(GetTicketStatusesSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      ticketStatusValues: res,
    },
  })),
  on(GetAssignmentsSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      ticketAssigneeValues: res,
    },
  })),
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      countryValues: res,
    },
  })),
  on(
    OpenCardsPanel,
    OpenCheckbooksPanel,
    OpenClubsPanel,
    OpenCouponsPanel,
    OpenPointLogPanel,
    OpenTransactionsPanel,
    (state, { displayedColumns }) => ({
      ...state,
      displayedColumns,
    }),
  ),
  on(OpenCampaignsPanel, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
    itemsNumber: 10,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(OpenTicketsPanel, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
    itemsNumber: 10,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(CheckbooksDisplayedColumnsInit, (state, { checkbooksDisplayedColumns }) => ({
    ...state,
    checkbooksDisplayedColumns,
  })),
  on(CheckbooksItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CheckbooksSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CheckbooksOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CheckbooksPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(SetSelectedCheckbook, (state, { bookCouponGroupId }) => ({
    ...state,
    selectedCheckbookId: bookCouponGroupId,
  })),
  on(PointLogDisplayedColumnsInit, (state, { pointLogDisplayedColumns }) => ({
    ...state,
    pointLogDisplayedColumns,
  })),
  on(TransactionsDisplayedColumnsInit, (state, { transactionsDisplayedColumns }) => ({
    ...state,
    transactionsDisplayedColumns,
  })),
  on(GetClubsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'clubs', false),
    clubs: res,
  })),
  on(GetClubsCountTableSuccess, (state, { res }) => ({
    ...state,
    totalPages: res,
  })),
  on(ClubsDisplayedColumnsInit, (state, { clubsDisplayedColumns }) => ({
    ...state,
    clubsDisplayedColumns,
  })),
  on(GetActiveClubsSuccess, (state, { res }) => ({
    ...state,
    activeClubs: res,
    assignClubForm: {
      clubCode: '',
      startDate: null,
      endDate: null,
    },
  })),
  on(AssignClubCodeChanged, (state, { clubCode }) => ({
    ...state,
    assignClubForm: {
      ...state.assignClubForm,
      clubCode,
    },
  })),
  on(AssignClubStartDateChanged, (state, { startDate }) => ({
    ...state,
    assignClubForm: {
      ...state.assignClubForm,
      startDate,
    },
  })),
  on(AssignClubEndDateChanged, (state, { endDate }) => ({
    ...state,
    assignClubForm: {
      ...state.assignClubForm,
      endDate,
    },
  })),
  on(SortingInit, (state, { sortFieldOptions, selectedSortField }) => ({
    ...state,
    sortFieldOptions,
    selectedSortField,
  })),
  on(OrderingInit, (state, { orderFieldOptions, selectedOrder }) => ({
    ...state,
    orderFieldOptions,
    selectedOrder,
  })),
  on(ItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(SortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(OrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(PagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(CampaignsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(CampaignsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(CampaignsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: {
      ...state.paginator,
      pageIndex: 0,
    },
  })),
  on(CampaignsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  // Point Log pagination
  on(PointLogItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(PointLogSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(PointLogOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(PointLogPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  // Transactions pagination
  on(TransactionsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TransactionsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TransactionsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TransactionsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  // Clubs pagination
  on(ClubsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(ClubsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(ClubsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(ClubsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  // Coupons pagination
  on(CouponsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CouponsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CouponsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(CouponsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  // Tickets pagination
  on(TicketsItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TicketsSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TicketsOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
    paginator: { ...state.paginator, pageIndex: 0 },
  })),
  on(TicketsPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(CheckbookDetailsModal, (state, { checkbook }) => ({
    ...state,
    checkbooksTable: checkbook?.bookCouponList ?? state.checkbooksTable,
  })),
  on(GetTicketsTableSuccess, (state, { res }) => ({
    ...setPanelLoading(state, 'tickets', false),
    tickets: res,
  })),
  on(MemberCreateTicketModal, (state) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      isCreateNewTicket: true,
      ticket: [],
      subject: '',
      body: '',
      ticketCategory: 0,
      ticketStatus: 0,
      ticketAssignee: 0,
      ticketSeverity: 0,
      country: 0,
      searchField: '',
      customerAdded: true,
      member: [],
      submit: false,
    },
  })),
  on(MemberEditTicketModal, (state, { editTicket }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      isCreateNewTicket: false,
      ticket: [editTicket],
      subject: editTicket.subject ?? '',
      body: editTicket.body ?? '',
      ticketCategory: editTicket.ticketCategoryId ?? 0,
      ticketStatus: editTicket.ticketStatusId ?? 0,
      ticketAssignee: editTicket.ticketAssigneeId ?? 0,
      ticketSeverity: editTicket.ticketSeverityId ?? 0,
      country: editTicket.countryId ?? 0,
      submit: false,
    },
  })),
  on(MemberCloseEditTicketModal, (state) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      isCreateNewTicket: true,
      ticket: [],
      ticketCategory: 0,
      ticketStatus: 0,
      ticketAssignee: 0,
      ticketSeverity: 0,
      subject: '',
      country: 0,
      body: '',
      searchField: '',
      customerAdded: false,
      memberColumns: [],
      member: [],
      submit: false,
    },
  })),
  on(TicketAssigneeChanged, (state, { ticketAssignee }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, ticketAssignee },
  })),
  on(TicketSeverityChanged, (state, { ticketSeverity }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, ticketSeverity },
  })),
  on(TicketStatusChanged, (state, { ticketStatus }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, ticketStatus },
  })),
  on(MemberTicketSearchFieldChanged, (state, { searchField }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, searchField },
  })),
  on(MemberTicketMatchMemberSuccess, (state, { res }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      customerAdded: res.length > 0,
      member: res,
    },
  })),
  on(MemberTicketRemoveMember, (state) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      customerAdded: false,
      member: [],
    },
  })),
  on(TicketSubjectChanged, (state, { subject }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, subject },
  })),
  on(TicketCountryChanged, (state, { country }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, country: Number(country) },
  })),
  on(TicketBodyChanged, (state, { body }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, body },
  })),
  on(TicketCategoryChanged, (state, { category }) => ({
    ...state,
    editTicketState: { ...state.editTicketState, ticketCategory: Number(category) },
  })),

  on(ClosePanel, ViewMemberSearchPage, () => initialState),
  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? {
          ...state,
        }
      : { ...initialState },
  ),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
  on(ToggleExecuteFlow, (state, { isExecuteFlowChecked }) => ({
    ...state,
    editTicketState: {
      ...state.editTicketState,
      ticket: [
        {
          ...state.editTicketState.ticket[0],
          executeFlow: isExecuteFlowChecked,
        },
      ],
    },
  })),
);
